import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AfterViewInit, Component, Inject, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { MeasurementsAbstractComponent } from '../../measurements-abastract.component';
import { AddAccessoryToSideInterface } from '../custom-shape.constants';
import { sideAccessories } from './add-accessory.constants';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'add-accessory-dialog',
  templateUrl: 'add-accessory-dialog.component.html',
  styleUrls: ['./add-accessory-dialog.component.scss'],
})
export class AddAccessoryDialogComponent extends MeasurementsAbstractComponent implements AfterViewInit {
  form = this.formBuilder.group({
    accessories: new UntypedFormControl(this.data.sideAccessory?.types || []),
  });
  accessoryTypes = sideAccessories;
  @ViewChild('accessories') accessories!: MatSelect;
  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<AddAccessoryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddAccessoryToSideInterface,
  ) {
    super();
  }

  onOkClick(): any {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value);
    }
  }

  ngAfterViewInit(): void {
    this.accessories.trigger.nativeElement.click();
  }
}
